import { Identite } from './identite';
import { AclRole } from './acl_role';
import { RoleRecherche } from './role-recherche';
import {NumeroClient} from "./NumeroClient";
import { IBureau } from '../../../core/shared/classes/bureau';
import { FacturePersonnalisation } from '../../../facturation/shared/classes/facture-personnalisation';

export interface IBureauConcerne {
    [key: string]: IBureau;
}

export class Role {

    id: string = null;
    ref: string;
    ref_metier: string;
    client_code_export_facture: string;
    acl_roles_id: string;
    identites_id: string;
    auxiliaire: string;
    num_auxiliaire: string;
    identite: Identite;
    acl_role: AclRole;
    archive: string;
    recherche_principale: RoleRecherche;
    agence_bureaux_id: string; // Sert à spécifier le bureau au back s'il n'est pas spécifié par le currentBureau du header
    bureau_concerne?: IBureauConcerne; // Uniquement pour les users pour pouvoir trier par bureau dans les select

    meta: any;

    z16ProChamps: Array<any> = [];
    z16gestion_honoraire: string = null; // Utilisé uniquement pour les propriétaires lorque z16gestion est actif

    numero_client: NumeroClient;
    associated_numero_client: NumeroClient[] = [];

    facture_personnalisation: FacturePersonnalisation = null;

    acl_roles_libelle: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.id                     = data['id'] ? data['id'] : null;
        this.ref                    = data['ref'] ? data['ref'] : null;
        this.ref_metier             = data['ref_metier'] ? data['ref_metier'] : null;
        this.client_code_export_facture = data['client_code_export_facture'] ? data['client_code_export_facture'] : null;
        this.acl_roles_id           = data['acl_roles_id'] ? data['acl_roles_id'] : null;
        this.identites_id           = data['identites_id'] ? data['identites_id'] : null;
        this.auxiliaire             = data['auxiliaire'] ? data['auxiliaire'] : null;
        this.num_auxiliaire         = data['num_auxiliaire'] ? data['num_auxiliaire'] : null;
        this.identite               = data['identite'] ? new Identite(data['identite']) : new Identite();
        this.acl_role               = data['acl_role'] ? new AclRole(data['acl_role']) : null;
        this.archive                = data['archive'] ? data['archive'] : '0';
        this.recherche_principale   = data['recherche_principale'] ? new RoleRecherche(data['recherche_principale']) : null;

        this.numero_client              = data['numero_client'] ? data['numero_client'] : [];
        this.associated_numero_client   = data['associated_numero_client'] ? data['associated_numero_client'] : [];
        this.acl_roles_libelle           = data['acl_roles_libelle'] ? data['acl_roles_libelle'] : null;

        this.meta = {};
    }


}
